import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useMemo, } from 'react';
import theme from '../../styles/theme';
import { alignments, types, } from './constants';
const alertVariationStyles = {
    [types.informative]: {
        backgroundColor: theme.colors.informative200,
    },
    [types.positive]: {
        backgroundColor: theme.colors.positive200,
    },
    [types.negative]: {
        backgroundColor: theme.colors.negative200,
    },
    [types.notice]: {
        backgroundColor: theme.colors.notice200,
    },
};
const defaultProps = {
    alignment: alignments.left,
    type: types.informative,
};
const AlertContainer = ({ alignment = defaultProps.alignment, children, type = defaultProps.type, }) => {
    const containerStyles = useMemo(() => (css `
        display: flex;
        padding-bottom: ${theme.spacing.x3};
        padding-left: ${theme.spacing.x3};
        padding-right: ${theme.spacing.x3};
        padding-top: ${theme.spacing.x3};
        background-color: ${alertVariationStyles[type].backgroundColor};
        color: ${theme.colors.gray700};
        flex-direction: ${alignment === alignments.center ? 'column' : 'row'};
        text-align: ${alignment};
      `), [
        alignment,
        type,
    ]);
    return (_jsx("div", Object.assign({ css: containerStyles }, { children: children })));
};
export { AlertContainer };
